export default {"src":"/_next/static/media/IP.fbe09fd8.svg","height":18,"width":18};